import { LOCATIONS, getLocation } from '../constants/locations.constant';
import { PRICE_TYPES, SALES_TAXES, SETUP_FEES, getPriceTypeByName, getSetupFeeByName } from '../constants/market.constant';
import { Location } from './location.model';
import { PriceType, SalesTax, SetupFee } from './market.model';

export class TransportConfiguration {
  averageNumberOfDays: number = 7;
  amount: number = 10;
  isPremium: boolean = true;
  buyPriceType: PriceType = PRICE_TYPES.sell;
  sellPriceType: PriceType = PRICE_TYPES.average;
  setupFee: SetupFee = SETUP_FEES.normal;
  buyLocation: Location = LOCATIONS.Caerleon;
  sellLocation: Location = LOCATIONS.BlackMarket;

  constructor() {}

  get salesTax(): SalesTax {
    if (this.isPremium) {
      return SALES_TAXES.premium;
    } else {
      return SALES_TAXES.normal;
    }
  }

  static fromJson(json: string): TransportConfiguration{
    
    const plainObject = JSON.parse(json);

    const result = Object.assign(new TransportConfiguration(), plainObject);

    result.buyLocation = getLocation(Number(result.buyLocation.index));
    result.sellLocation = getLocation(Number(result.sellLocation.index));

    result.buyPriceType = getPriceTypeByName(result.buyPriceType.name);
    result.sellPriceType = getPriceTypeByName(result.sellPriceType.name);

    result.setupFee = getSetupFeeByName(result.setupFee.name);

    return result;
  }
}
